import { GlobalFooter } from "@hagerty/global-navigation";

type FooterProps = {
  headerDataApiUrl: string;
};

export function Footer({ headerDataApiUrl }: FooterProps) {
  return (
    <GlobalFooter
      dataApi={headerDataApiUrl}
      isMinimal={true}
      showSitemap={false}
    />
  );
}
